export default __webpack_public_path__ + "static/media/2-large.22a26b59.webp";